module.exports = __webpack_public_path__ + "img/thumb_08.a689d9c0.jpg";